import { darken } from 'polished';
import { boxShadow } from '../../mixins';
export function stateInteraction() {
  var baseColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#000';
  var inverted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var forceRetrieveState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var invertedBaseColor = '#fff';
  var backgroundColor = {
    hover: inverted ? baseColor : darken(0.1, baseColor),
    focus: inverted ? invertedBaseColor : darken(0.1, baseColor),
    active: darken(0.15, baseColor)
  };
  var stateMap = {
    hover: "\n      background-color: ".concat(backgroundColor.hover, ";\n      color: ").concat(inverted && invertedBaseColor, ";\n    "),
    focus: "\n      background-color: ".concat(backgroundColor.focus, ";\n      color: ").concat(inverted && baseColor, ";\n      ").concat(boxShadow(baseColor), "\n    "),
    active: "\n      background-color: ".concat(backgroundColor.active, ";\n      color: ").concat(inverted && invertedBaseColor, ";\n      ").concat(boxShadow(baseColor), "\n    ")
  };

  if (forceRetrieveState) {
    return stateMap[forceRetrieveState];
  }

  return "\n    &:hover {\n      ".concat(stateMap.hover, "\n    }\n    &:focus {\n      ").concat(stateMap.focus, "\n    }\n    &:active {\n      ").concat(stateMap.active, "\n    }\n  ");
}